import React, { useContext } from 'react';
import { string, any, bool } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { DynamicRecsWrapper } from './DynamicRecsWrapper';
import { SearchViewedWrapper } from '../search-viewed/SearchViewedWrapper';
import ZoneCard from '../utils/zone-card';
import { dynamicRecsDataModel } from '../dataModel';

const PlpRecsRenderPlaceholder = ({
  isBrowse,
  requestKey,
  keyword,
  showLoading,
  itemIds
}) => {

  const { isServer } = useContext(ExperienceContext);
  const schemeName = isBrowse ? 'plpbrowse_multi' : 'searchViewed';
  const items = itemIds?.length > 0 ? itemIds.toString() : '';

  if (!schemeName || !!isServer) return null;

  return (
    <Col>
      {isBrowse ? (
        <Row>
          <ErrorBoundary name={schemeName}>
            <DynamicRecsWrapper
              schemaName={schemeName}
              requestKey={requestKey}
              anchorId={items}
              showLoading={showLoading}
              serviceType="mutlianchor"
              hydrator={{
                delay: 1500,
                scrollBuffer: 750,
                className: 'grid',
                tag: ZoneCard,
                id: `${schemeName}-${itemIds?.[0]}`
              }}
            />
          </ErrorBoundary>
        </Row>
      ) : (
        <Row>
          <ErrorBoundary name={schemeName}>
            <SearchViewedWrapper
              schemaName={schemeName}
              anchorId={keyword}
              requestKey={requestKey}
              showLoading={showLoading}
              itemIds={items}
              hydrator={{
                className: 'grid',
                tag: ZoneCard,
                id: `${schemeName}-${itemIds?.[0]}-${keyword}`
              }}
            />
          </ErrorBoundary>
        </Row>
      )}
    </Col>
  );
};

PlpRecsRenderPlaceholder.displayName = 'PlpRecsRenderPlaceholder';
PlpRecsRenderPlaceholder.dataModel = dynamicRecsDataModel;

PlpRecsRenderPlaceholder.propTypes = {
  isBrowse: bool,
  showLoading: bool,
  requestKey: string.isRequired,
  keyword: string,
  // eslint-disable-next-line react/forbid-prop-types
  itemIds: any
};

PlpRecsRenderPlaceholder.defaultProps = {
  isBrowse: false,
  showLoading: true,
  keyword: '',
  itemIds: null
};

export { PlpRecsRenderPlaceholder };